import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Scale } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Footer from './components/Footer';

const TermsPage = () => {
  return (
    <div className="app-container" data-theme="dark" style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <Link to="/">
          <Button variant="ghost" style={{ marginBottom: '1.5rem' }} data-testid="terms-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao inicio
          </Button>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '2rem' }}>
          <Scale className="w-8 h-8" style={{ color: '#00ffff' }} />
          <h1 style={{ fontSize: '1.75rem', fontWeight: '700' }}>Termos de Uso</h1>
        </div>

        <div style={{ color: '#ccc', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <p style={{ color: '#888', marginBottom: '2rem' }}>Última atualização: Dezembro de 2025</p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>1. Aceitação dos Termos</h2>
            <p>Ao acessar e utilizar a plataforma <strong>Atlas.IA</strong> (<a href="https://atlasaifinances.com" style={{ color: '#00ffff' }}>https://atlasaifinances.com</a>), operada pela <strong>VLM Corp.</strong>, você concorda com estes Termos de Uso. Caso não concorde, não utilize o serviço o servico.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>2. Descrição do Serviço</h2>
            <p>A Atlas.IA e uma plataforma de consultoria empresarial que utiliza inteligência artificial para fornecer:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Orientação financeira e educação financeira contextual.</li>
              <li style={{ marginBottom: '0.5rem' }}>Análise de risco empresarial.</li>
              <li style={{ marginBottom: '0.5rem' }}>Análise de fluxo de caixa e planejamento de expansão.</li>
              <li style={{ marginBottom: '0.5rem' }}>Separação de finanças PJ e PF.</li>
              <li style={{ marginBottom: '0.5rem' }}>Análise de documentos financeiros.</li>
              <li style={{ marginBottom: '0.5rem' }}>Sessões de consultoria humana (conforme plano contratado).</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>3. Natureza do Serviço</h2>
            <div style={{ background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.3)', borderRadius: '8px', padding: '1rem', marginBottom: '0.75rem' }}>
              <p><strong>IMPORTANTE:</strong> A Atlas.IA fornece orientações de caráter educacional e informativo. As recomendações da IA não substituem consultoria profissional de contadores, advogados ou consultores financeiros certificados. Decisões de negócios devem ser tomadas com acompanhamento profissional adequado.</p>
            </div>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>4. Cadastro e Conta</h2>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Você deve fornecer informações verdadeiras e mantê-las atualizadas.</li>
              <li style={{ marginBottom: '0.5rem' }}>Você é responsável pela segurança de sua senha e acesso à conta.</li>
              <li style={{ marginBottom: '0.5rem' }}>Cada conta e pessoal e intransferível (exceto dependentes no plano Empresarial).</li>
              <li style={{ marginBottom: '0.5rem' }}>Menores de 18 anos devem ter autorização de responsável legal.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>5. Planos e Pagamentos</h2>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Os preços e benefícios de cada plano estão descritos na página de planos da plataforma.</li>
              <li style={{ marginBottom: '0.5rem' }}>Os pagamentos são processados de forma segura pelo <strong>Stripe</strong>.</li>
              <li style={{ marginBottom: '0.5rem' }}>Assinaturas são renovadas automaticamente, salvo cancelamento prévio.</li>
              <li style={{ marginBottom: '0.5rem' }}>A VLM Corp. reserva-se o direito de alterar preços com aviso prévio de 30 dias.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>6. Sistema de Créditos</h2>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Cada interação com a IA consome créditos conforme a tabela de custos da plataforma.</li>
              <li style={{ marginBottom: '0.5rem' }}>Créditos do plano são renovados mensalmente e não são cumulativos.</li>
              <li style={{ marginBottom: '0.5rem' }}>Créditos comprados avulsamente não expiram.</li>
              <li style={{ marginBottom: '0.5rem' }}>Créditos consumidos não são reembolsáveis.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>7. Uso Proibido</h2>
            <p>E expressamente proibido utilizar a Atlas.IA para:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Solicitar orientações sobre atividades ilegais (sonegação, fraude fiscal, lavagem de dinheiro, etc.).</li>
              <li style={{ marginBottom: '0.5rem' }}>Tentar burlar os filtros de segurança da IA.</li>
              <li style={{ marginBottom: '0.5rem' }}>Compartilhar conteúdo ofensivo, difamatório ou ilegal.</li>
              <li style={{ marginBottom: '0.5rem' }}>Revender ou redistribuir o servico sem autorização.</li>
              <li style={{ marginBottom: '0.5rem' }}>Utilizar bots ou automações não autorizadas.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>8. Propriedade Intelectual</h2>
            <p>Todo o conteúdo da plataforma (design, código, marca, textos) é propriedade da <strong>VLM Corp.</strong> As respostas geradas pela IA são de uso pessoal do usuário para fins de gestão do seu negócio.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>9. Limitação de Responsabilidade</h2>
            <p>A VLM Corp. não se responsabiliza por:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Decisões tomadas com base nas orientações da IA.</li>
              <li style={{ marginBottom: '0.5rem' }}>Perdas financeiras decorrentes do uso das recomendações.</li>
              <li style={{ marginBottom: '0.5rem' }}>Indisponibilidade temporária do serviço por manutenção ou força maior.</li>
              <li style={{ marginBottom: '0.5rem' }}>Imprecisoes nas analises geradas pela inteligência artificial.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>10. Suspensão e Encerramento</h2>
            <p>A VLM Corp. pode suspender ou encerrar contas que violem estes termos, sem aviso prévio e sem reembolso. O usuário pode encerrar sua conta a qualquer momento entrando em contato pelo email de suporte.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>11. Alterações nos Termos</h2>
            <p>Estes termos podem ser atualizados a qualquer momento. Alterações significativas serão comunicadas aos usuarios. O uso continuado da plataforma após alterações constitui aceitação dos novos termos.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>12. Foro e Legislação Aplicável</h2>
            <p>Estes termos sao regidos pela legislação brasileira. Quaisquer disputas serao submetidas ao foro da comarca da sede da VLM Corp.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>13. Contato</h2>
            <p><strong>VLM Corp.</strong> - Fundadora da Atlas.IA</p>
            <p>Email: <a href="mailto:suporteatlasia@hotmail.com" style={{ color: '#00ffff' }}>suporteatlasia@hotmail.com</a></p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;
